exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner--icon.width-limited{max-width:660px}.banner--icon .banner-content{margin-left:2rem}.banner--icon .banner-content .banner-title,.banner--icon .banner-content .banner-title span{font-family:Avenir-Heavy;font-size:20px;line-height:26px}.banner--icon .banner-content .banner-copy{font-size:15px;line-height:24px;margin-top:10px}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};